import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined, SyncOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingShortLinkStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingShortLinkStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingShortLinkStore.onSearchJobAction({
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser
    })
    marketingShortLinkStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingShortLinkStore.onGetStatus('shortLinkStatus')
    marketingShortLinkStore.onGetStatus('shortLinkType')
    marketingShortLinkStore.onRemainingNumberAction()
  }

  handleSearch = () => {
    const {marketingShortLinkStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketGroupId': fieldsValue.marketGroupId,
        'configName': fieldsValue.configName,
        'shortLinkType': fieldsValue.shortLinkType,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingShortLinkStore.onSearchJobAction(params)
      marketingShortLinkStore.onRemainingNumberAction()
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  handleSync = () => {
    const {marketingShortLinkStore} = this.props
    marketingShortLinkStore.onSyncAction()
  }
  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {marketingShortLinkStore, location, t, accountStore} = this.props
    const {groupList, typeList} = marketingShortLinkStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout={themeStyle?.layoutHorizontal ? "horizontal" : "vertical"}>

          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

              <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

              <Form.Item name="configName" label={t(`marketingManagement.shortLinkName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.shortLinkName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={themeStyle?.layoutHorizontal ? 6 : 4}>

              <Form.Item name="shortLinkType" label={t(`marketingManagement.shortLinkType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {typeList?.map(item => (<Select.Option key={item?.code} value={item?.code}>{item?.name}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={themeStyle?.layoutHorizontal ? 6 : 12} style={{textAlign: 'right', marginTop: themeStyle?.layoutHorizontal ? 0 : 30}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>

              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
              {isPowerUser ? <Button onClick={this.handleSync} type="primary" icon={<SyncOutlined />}>{t(`general.sync`)}</Button> : null}
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
